import React, { useState, useEffect } from "react";
import * as S from "./styles";
import CompTextField from "components/CompTextField";
import CompDateField from "components/CompDateField";
import { NisField } from "components/NisField";
import Button from "@mui/material/Button";
import * as palette from "styles/variables";
import LoopIcon from '@mui/icons-material/Loop';
import ModalMinorToResp from "components/ModalMinorToResp";
import { useApi } from "hooks/useApis";
import SuccessAlert from "components/Alerts/SuccessAlert";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import { serverErrorMsg } from "utils/constants";

const Forms = ({
  beneficiaryData,
  isView,
  isEdit,
  register,
  unregister,
  watch,
  setValue,
  errors,
}) => {
  
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  
  const api = useApi();
  
  const nis = watch("pregnant_nis");

  const handleNis = (data) => {
    setValue("pregnant_name", data?.name);
    setValue("pregnant_cpf", data?.cpf);
    setValue("pregnant_birth", data?.birth);
    setValue('rg', data?.rg);
    setValue('rg_issuer', data?.rg_issuer);
    setValue('rg_uf', data?.rg_uf);
  }

  const CustomButton = ({ text, color, hoverColor, onClick}) => (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: color,
        color: '#FFFFFF',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '1.1em',
        '&:hover': {
          backgroundColor: hoverColor,
        },
        width: '250px',
        bottom: 20
      }}
      startIcon={<LoopIcon/> }

    >
      {text}
    </Button>
  );

  const onSubmitChangeResp = async () => {
      try {
        setIsLoading(true)
        const response = await api.putChangeMinorToResponsible(beneficiaryData?.id);
        setOpenModal(false)
        setIsLoading(false)
        setAlertType('success')
        setAlertMessage("Benefício atualizado com sucesso!")
      } catch (err) {
        setAlertType('error')
        setAlertMessage(err?.status === 500 ? serverErrorMsg : err?.response?.data?.detail)
        setIsLoading(false)
        console.log(err);
      }
    };

  return (
    <S.Form>
      <S.FormGeral>
        <S.DadosBox>
          <S.FormRowGestanteMenor>
            {/* Linha 1 */}

            <NisField
              textLabel="NIS:"
              benefitNis={beneficiaryData?.pregnant_nis}
              nis={nis}
              isView={isView}
              isEdit={isEdit}
              apiText={beneficiaryData?.pregnant_nis}
              name="pregnant_nis"
              register={register}
              unregister={unregister}
              error={errors.pregnant_nis}
              helperText={errors.pregnant_nis}
              handleNis={handleNis}
              setValue={setValue}
              b_status={beneficiaryData?.b_status}
            />

            <CompTextField
              isView={isView}
              apiText={beneficiaryData?.pregnant_name}
              textLabel="NOME COMPLETO:"
              required
              fromNis={true}
              // enabled={false}
              style={{ flexGrow: "1" }}
              name="pregnant_name"
              register={register}
              unregister={unregister}
              error={errors.pregnant_name}
              helperText={errors.pregnant_name && errors.pregnant_name.message}
            />
          </S.FormRowGestanteMenor>

          <S.FormRowGestanteMenor>
            {/* Linha 2 */}
            <CompTextField
              isView={isView}
              apiText={beneficiaryData?.pregnant_cpf}
              textLabel="CPF:"
              fromNis={true}
              //mask="999.999.999-99"
              placeholder="xxx.xxx.xxx-xx"
              required
              // enabled={false}
              name="pregnant_cpf"
              register={register}
              unregister={unregister}
              style={{ flexGrow: "1" }}
              error={errors.pregnant_cpf}
              helperText={errors.pregnant_cpf && errors.pregnant_cpf.message}
            />
            <CompDateField
              isView={isView}
              labelText="DATA DE NASCIMENTO:"
              apiText={beneficiaryData?.pregnant_birth}
              required
              disabled={true}
              name="pregnant_birth"
              fromNis={true}
              register={register}
              unregister={unregister}
              error={errors.pregnant_birth}
              helperText={
                errors.pregnant_birth && errors.pregnant_birth.message
              }
            />
          </S.FormRowGestanteMenor>
        </S.DadosBox>
      </S.FormGeral>
      {isEdit &&
        <CustomButton 
          text={"Tornar Responsável"}
          color={palette.lightAmarelo}
          hoverColor={palette.darkLaranja}
          onClick={() => setOpenModal(true)}
          />}
        <ModalMinorToResp
          open={openModal}
          handleClose={() => setOpenModal(false)}
          onSubmit={onSubmitChangeResp}
          // isLoading={isLoading}
          />
        <SuccessAlert
        open={alertType === "success"}
        onClose={() => {setAlertType(""); window.location.reload()}}
        alertText={alertMessage}
      />
      <FillErrorAlert
        open={alertType === "error"}
        title="Erro!"
        onClose={() => {setAlertType(""); window.location.reload()}}
        message={alertMessage}
      />
    </S.Form>
  );
};

export default Forms;
